(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["live-product-viewers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('live-product-viewers')) {
    class LiveProductViewers extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') {
          return;
        }

        this.dataset.initialized = 'true';

        this.countElement = this.querySelector(
          '.live-product-viewers__count'
        );

        let minimum = Number(this.dataset.minimum) || 8;
        let maximum = Number(this.dataset.maximum) || 24;

        if (minimum > maximum) {
          const oldMinimum = minimum;
          minimum = maximum;
          maximum = oldMinimum;
        }

        this.minimum = minimum;
        this.maximum = maximum;

        const productId = this.dataset.productId || 'default';

        this.storageKey = `live-product-viewers-${productId}`;

        const savedCount = this.getSavedCount();

        if (savedCount !== null) {
          this.viewerCount = savedCount;
        } else {
          this.viewerCount = this.getRandomNumber(
            this.minimum,
            this.maximum
          );
        }

        this.displayCount();
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        if (this.updateTimer) {
          window.clearTimeout(this.updateTimer);
        }
      }

      getRandomNumber(minimum, maximum) {
        return Math.floor(
          Math.random() * (maximum - minimum + 1)
        ) + minimum;
      }

      getSavedCount() {
        try {
          const savedValue = sessionStorage.getItem(
            this.storageKey
          );

          if (savedValue === null) {
            return null;
          }

          const savedCount = Number(savedValue);

          if (
            Number.isFinite(savedCount) &&
            savedCount >= this.minimum &&
            savedCount <= this.maximum
          ) {
            return savedCount;
          }
        } catch (error) {
          return null;
        }

        return null;
      }

      saveCount() {
        try {
          sessionStorage.setItem(
            this.storageKey,
            String(this.viewerCount)
          );
        } catch (error) {
          // Continue without browser session storage.
        }
      }

      displayCount() {
        if (!this.countElement) {
          return;
        }

        this.countElement.textContent = this.viewerCount;
        this.saveCount();
      }

      updateCount() {
        const possibleChanges = [-1, 0, 0, 0, 1];

        const selectedIndex = this.getRandomNumber(
          0,
          possibleChanges.length - 1
        );

        const change = possibleChanges[selectedIndex];

        this.viewerCount = Math.min(
          this.maximum,
          Math.max(
            this.minimum,
            this.viewerCount + change
          )
        );

        this.displayCount();
        this.scheduleUpdate();
      }

      scheduleUpdate() {
        const delay = this.getRandomNumber(8000, 15000);

        this.updateTimer = window.setTimeout(
          () => this.updateCount(),
          delay
        );
      }
    }

    customElements.define(
      'live-product-viewers',
      LiveProductViewers
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
